import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ImportContainer} from 'app/Model/dataProcess/importContainer';
import {ExportContainer} from 'app/Model/dataProcess/exportContainer';
import {ProductDataSource} from 'app/Model/dataProcess/productDataSource';
import {DataSourcesService} from 'app/Services/DataProcess/datasources.service';
import {LoginService} from 'app/Services/login.service';
import {Address} from "../../../Model/Catalog/Address";
import {ContainerType} from '../inspectPanel.component';
import {ImportContainerService} from 'app/Services/DataProcess/import-container.service';
import {ExportContainerService} from 'app/Services/DataProcess/export-container.service';
import {TranslateService} from '@ngx-translate/core';
import {confirm} from 'devextreme/ui/dialog';
import {CatalogService} from 'app/Services/CatalogManagement/catalog.service';
import {Brand} from "../../../Model/Dto/Brand/Brand";

@Component({
  selector: 'np-inspect-container-details-context',
  templateUrl: './inspect-container-details-context.component.html',
  styleUrl: './inspect-container-details-context.component.css',
  standalone: false
})
export class InspectContainerDetailsContextComponent {
  @Output() containerSaved = new EventEmitter<ImportContainer | ExportContainer>();
  @Output() containerDeleted = new EventEmitter<void>();
  @Output() containerDuplicated = new EventEmitter<ImportContainer | ExportContainer>();
  @Input() containerType: ContainerType = 'import';
  
  dataSource: ProductDataSource;
  activeCatalogName = '';
  editVisible = false;
  dataSourcePopupVisible = false;
  DataSourceEditMode = false;
  relatedBrands: Brand[] = [];
  showChangeWarningForEditDialog = true;
  productDataSources: ProductDataSource[] = [];
  constructor(
    public dataSourceService: DataSourcesService,
    private loginService: LoginService,
    private importContainerService: ImportContainerService,
    private exportContainerService: ExportContainerService,
    private catalogService: CatalogService,
    private translate: TranslateService
  ) {
    this.loadSupplier = this.loadSupplier.bind(this);
  }

  private _container: ImportContainer | ExportContainer;

  get container(): ImportContainer | ExportContainer {
    return this._container;
  }

  @Input()
  set container(value: ImportContainer | ExportContainer) {
    this._container = value;
    this.loadSupplier().then();
    this.resolveActiveCatalogName().then();
  }

  async loadSupplier(): Promise<void> {
    if (this.container) {
      this.dataSource = await this.dataSourceService.get(this.container.dataSourceId, this.loginService.currentCustomer.id);
      if (this.dataSource && !this.dataSource.importerAddress) {
        this.dataSource.importerAddress = new Address();
      }
    }
  }

  private async resolveActiveCatalogName(): Promise<void> {
    const c = this._container as ImportContainer;
    const activeId = c?.activeCatalogId;
    const customerId = this.loginService?.currentUser?.customerId;
    if (!activeId || !customerId) {
      this.activeCatalogName = '';
      return;
    }
    try {
      this.activeCatalogName = await this.catalogService.getCatalogName(activeId, customerId) ?? '';
    } catch {
      this.activeCatalogName = '';
    }
  }

  openContainerEdit(): void {
    this.editVisible = true;
  }

  async duplicateContainer(): Promise<void> {
    const c = this._container as ImportContainer;
    if (!c) return;
    const copy: ImportContainer = structuredClone(c);
    copy.id = null;
    copy.createdByUserId = this.loginService.currentUser.id;
    copy.name += '_COPY';
    const created = await this.importContainerService.create(copy, this.loginService.currentCustomer.id);
    this.containerDuplicated.emit(created);
  }

  async deleteContainer(): Promise<void> {
    const c = this._container as ImportContainer;
    if (!c) return;
    const confirmed = await confirm(
      this.translate.instant('Soll der Container wirklich gelöscht werden? -') + ' <b>' + c.name + '</b>',
      this.translate.instant('Container löschen')
    );
    if (!confirmed) return;
    await this.importContainerService.deleteByContainerId(c.id, c.createdByUserId, this.loginService.currentCustomer.id);
    this.containerDeleted.emit();
  }

  async onContainerSaved(updated: ImportContainer | ExportContainer) {
    this.containerSaved.emit(updated);
  }

  async saveContainerNote(): Promise<void> {
    if (!this._container) return;
    const customerId = this.loginService.currentCustomer.id;
    if (this.containerType === 'export') {
      await this.exportContainerService.update(this._container as ExportContainer, customerId);
    } else {
      await this.importContainerService.update(this._container as ImportContainer, customerId);
    }
  }

  openSupplierEdit() {
    this.showChangeWarningForEditDialog = true;
    this.dataSourcePopupVisible = true;
  }

  async onEditSaved(event: ProductDataSource) {
    this.dataSource = event;
    this.container.dataSourceId = this.dataSource.id;
    
    const changedImportContainer = this.container as ImportContainer;
    await this.importContainerService.update(changedImportContainer, this.loginService.currentCustomer.id)
  }
}
